import React, { useState } from "react";
import "../../Pages/Styles/common-styles.css"

const SuggestButton = ({ postId, postTitle, context = "", nsuggest=0 }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [userId, setUserId] = useState("");
  const [profileId, setProfileId] = useState("");
  const className = context === "userProfile" ? "up-text-label" : "text-label";

  // Handle the suggestion action
  const handleSuggest = () => {
    if (!userId) {
      alert("Please enter a User ID to suggest the post.");
      return;
    }

    console.log(`Suggesting post "${postTitle}" (ID: ${postId}) to User ID: ${userId}, Profile ID: ${profileId || "default users"}`);
    
    // Close popup after submission
    setShowPopup(false);
    
    // You can replace this with an actual API call, e.g.:
    // fetch("/api/suggest", { method: "POST", body: JSON.stringify({ postId, userId, profileId }) });
  };

  return (
    <div style={{marginTop: 5}}>
      {/* Suggest span acting as a button */}
      <span 
        onClick={() => setShowPopup(true)}
        className={className}
        style={{marginLeft: 30}}
      >
        📌
      </span>

      {/* Popup Container */}
      {showPopup && (
        <div style={{
          position: "absolute",
          top: "66%",
          left: "52%",
          transform: "translate(-50%, -50%)",
          background: "white",
          padding: "20px",
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
          zIndex: 1000,
          background: "lightgray",
          color: "black"
        }}>
          <h3>Suggest Post</h3>
          <input
            type="text"
            placeholder="Enter User ID"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
            style={{ padding: "5px", marginBottom: "10px", display: "block" }}
            color="darkgray"
          />
          <input
            type="text"
            placeholder="Enter Profile ID (Optional)"
            value={profileId}
            onChange={(e) => setProfileId(e.target.value)}
            style={{ padding: "5px", marginBottom: "10px", display: "block" }}
          />
          <button onClick={handleSuggest} style={{ marginRight: "10px", cursor: "pointer" }}>
            Confirm
          </button>
          <button onClick={() => setShowPopup(false)} style={{ cursor: "pointer" }}>
            Cancel
          </button>
        </div>
      )}
    </div>
  );
};

export default SuggestButton;
